import React, { useState, FormEvent } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next"
import { connect, useDispatch } from 'react-redux'
import { AppState } from '../../reducers'
import { updateCredentials } from '../../actions/auth/updateCredentials'
import { pushAlert } from '../../actions/alert'
import { CssBaseline, ThemeProvider, Typography } from "@mui/material"
import ProgressButton from '../Utils/ProgressButton'
import NewPassword from '../Utils/NewPassword'
import ISCard from '../Utils/ISCard'
import { useThemeContext } from '../../theme/ThemeContext';

const PasswordRecovery: React.FC<StateProps> = ({ passwordRecovery }) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {t} = useTranslation("login")
  const { theme } = useThemeContext()

  const [newPassword, setNewPassword] = useState<string | null>(null)

  const handleChangePassword = (event: FormEvent) => {
    event.preventDefault()
    
    dispatch(updateCredentials({ newPassword: newPassword! }, () => {
      dispatch(pushAlert(t("changedPassword")))
      history.push('/login')
    })(location.search))
  }

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline/>

    <ISCard>
      <Typography align="center" variant="subtitle1">
        {t("enterNewPassword")}
      </Typography>
      <form onSubmit={handleChangePassword}>
        <NewPassword onValidPassword={setNewPassword} />
        <ProgressButton state={passwordRecovery} disabled={!newPassword}>
          {t("changePasswordButton")}  
        </ProgressButton>
      </form>
    </ISCard>
    </ThemeProvider>
  )
}


type StateProps = ReturnType<typeof mapStateToProps>
const mapStateToProps = ({ passwordRecovery }: AppState) => ({ passwordRecovery })

export default connect(mapStateToProps, null)(PasswordRecovery)